export var LLMs;
(function (LLMs) {
    LLMs["OpenAI"] = "openai";
})(LLMs || (LLMs = {}));
export var ChatCompletionModels;
(function (ChatCompletionModels) {
    ChatCompletionModels[ChatCompletionModels["trivial"] = 0] = "trivial";
    ChatCompletionModels[ChatCompletionModels["critical"] = 1] = "critical";
})(ChatCompletionModels || (ChatCompletionModels = {}));
export class LLM {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    constructor(logger, useLessCapableModel) { }
}
